import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import {
  createAccessRole,
  fetchAccessRoleById,
  fetchRoleMaster,
  updateAccessRole
} from "../../../_redux/access-role/accessRoleAction";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import AccessRoleEditForm from "./AccessRoleEditForm";

export default function AccessRoleForm({
  history,
  match: {
    params: { id }
  }
}) {
  const dispatch = useDispatch();

  const { accessRoleForEdit, actionsLoading, roleMaster } = useSelector(
    state => state.superAdminAccessRole,
    shallowEqual
  );

  useEffect(() => {
    dispatch(fetchRoleMaster());
    if (id) {
      dispatch(fetchAccessRoleById(id));
    }
  }, [dispatch, id]);

  function goToList() {
    history.push("/admin/master-data/access-role");
  }

  const onSubmitRole = values => {
    if (id) {
      dispatch(updateAccessRole(values)).then(res => {
        toast.success(res.data.message);
        goToList();
      });
    } else {
      dispatch(createAccessRole(values)).then(res => {
        toast.success(res.data.message);
        goToList();
      });
    }
  };

  const initAccessRole = {
    name: "",
    access: []
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title={`${id ? "Edit" : "Tambah"} Akses Role`}>
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-secondary"
              onClick={goToList}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <AccessRoleEditForm
            defaultValues={id ? accessRoleForEdit || {} : {}}
            onSubmit={onSubmitRole}
            accessRole={accessRoleForEdit || initAccessRole}
            roleMaster={roleMaster}
          />
        </CardBody>
      </Card>
    </>
  );
}
